import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Spinner from '../common/Spinner';

const useStyles = makeStyles(() => ({
  wrapper: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 1000,
  },
}));

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const SavingOverlay = () => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <Spinner />
    </div>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default SavingOverlay;
